// Port of api/fuel/app/classes/filter/search/games/sorts/query/collection/inventory/location.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'inventory.location',
	post: false,
	require: function(config, filter) {
		return sorted('inventory.location', filter) > 0 && config.can && config.can['view.inventory.location']
	},
	run: function(config, filter, data, query) {
		if (sortReverse('inventory.location', filter)) {
			query.order('c.collection_private_location', true, sortPriority('inventory.location', filter))
		} else {
			query.order("COALESCE(IFNULL(NULLIF(c.collection_private_location, ''), 'zzzzzzzzzz'), c.collection_private_location)", false, sortPriority('inventory.location', filter))
		}
	}
}
